import React from "react";

function Footer() {
  return (
    <div
      style={{
        height: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: ".8rem",
        // backgroundColor: "rgb(93, 153, 148)",
        // color: "white",
      }}
    >
      SPACE BE © 2022 All rights reserved
    </div>
  );
}

export default Footer;
